const Theme = {
  font: {
    size: {
      DEFAULT: '1rem',
      '2xs': '0.625rem',
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1.125rem',
      lg: '1.5rem',
      xl: '2rem',
      '2xl': '2.5rem',
    },
    weight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      DEFAULT: '140%',
      md: '1.5rem',
      lg: '2rem',
      xl: '2.5rem',
      '2xl': '3rem',
    },
  },
  color: {
    primary: '#69CE8C',
    warning: '#F2C94C',
    danger: '#EB5757',
    shopify: '#707070',
    wolt: '#00C2E8',
    success: '#16a249',
  },
  spacing: {
    none: '0px',
    nano: '2px',
    '2xs': '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '40px',
  },
};

export default Theme;
